import { Fragment } from "react";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import { useWindowSize } from "@hooks/useWindowSize";
import SingaporeGeComponentFactory from "@pages/SingaporeGe/2025/components/SingaporeGeComponentFactory";
import { SingaporeGEBasicProps } from "@pages/SingaporeGe/2025/utils/types";
import { cn } from "@util/helpers";

/**
 * SectionsTemplate component to render the sections based on the provided configuration.
 */
const SectionsTemplate = ({
  relatedStories,
  configData: parentConfig,
  highlights,
  index,
  entity,
}: SingaporeGEBasicProps): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  const displayChildren =
    parentConfig?.children && parentConfig?.children?.length > 0;

  const isVisible =
    (parentConfig?.onlyMobile && !isScreenLG) ||
    (parentConfig?.onlyDesktop && isScreenLG) ||
    (!parentConfig?.onlyDesktop && !parentConfig?.onlyMobile);

  return (
    <Row rootClassName="mb-0" data-testid="ge-2025-bottom-section-component">
      <>
        {isVisible ? (
          <Column
            rootClassName={cn("w-full lg:w-8/12", {
              "lg:w-full": !displayChildren,
            })}
          >
            <SingaporeGeComponentFactory
              configData={parentConfig}
              highlights={highlights}
              relatedStories={relatedStories}
              index={index}
              parentIndex={index}
              entity={entity}
            />
          </Column>
        ) : null}
      </>

      <>
        {displayChildren ? (
          <Column rootClassName="w-full lg:w-4/12">
            {parentConfig?.children?.map((childConfig, childIndex) => {
              const isVisible =
                (childConfig?.onlyMobile && !isScreenLG) ||
                (childConfig?.onlyDesktop && isScreenLG) ||
                (!childConfig?.onlyDesktop && !childConfig?.onlyMobile);

              if (!isVisible)
                return (
                  <Fragment key={`${childConfig.type}-child-${childIndex}`} />
                );

              return (
                <SingaporeGeComponentFactory
                  key={`${childConfig.type}-child-${childIndex}`}
                  configData={childConfig}
                  highlights={relatedStories}
                  relatedStories={highlights}
                  index={childIndex}
                  parentIndex={index}
                  entity={entity}
                />
              );
            })}
          </Column>
        ) : null}
      </>
    </Row>
  );
};

export default SectionsTemplate;
